import * as React from 'react';
import * as styles from './ContentOrganizerPermissionsTargetingPanel.css';
import { ContentOrganizerStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { LocalizationService } from "../../../services/LocalizationService";
import { ContentOrganizerPermissions } from '../permissions/ContentOrganizerPermissions';
import { IATargetingApplication } from '../../targetingApplication/TargetingApplication';
import { IApplication } from '../../../interfaces/IApplication';
import { TargetingService } from '../../../services/TargetingService';
import { IASpinner } from '../../spinner/Spinner';

export interface IContentOrganizerPermissionsTargetingPanelProps {
  contentOrganizerStore?: ContentOrganizerStore;
  beforeIaReady: () => void;
  afterIaReady: () => void;
  onSelectedStep: (step) => void;
}

export interface IContentOrganizerPermissionsTargetingPanelState {
}

@inject('contentOrganizerStore')
@observer
export class ContentOrganizerPermissionsTargetingPanel extends React.Component<IContentOrganizerPermissionsTargetingPanelProps, IContentOrganizerPermissionsTargetingPanelState> {

  constructor(props: IContentOrganizerPermissionsTargetingPanelProps) {
    super(props);
    this.promiseLoadApplicationSettings();
  }

  private promiseLoadApplicationSettings = (): Promise<void> => {
    this.props.contentOrganizerStore.permissions = [];
    return new Promise<void>((resolve: () => void): void => {
      const targetingServicePromise = TargetingService.getApplicationsTargetSettings(this.props.contentOrganizerStore.environment, this.props.contentOrganizerStore.tenant, this.props.contentOrganizerStore.token)
        .then((applications: IApplication[]) => {
          this.props.contentOrganizerStore.applicationsData = applications;
        });
      Promise.all([targetingServicePromise])
        .then(() => {
          this.props.contentOrganizerStore.isLoadingApplication = false;
          resolve();
        });
    });
  }

  public render(): JSX.Element {
    let panel = (
      <div className={styles.IPermissionsTargeting_panel}>
        <div className={styles.IPermissionsTargeting_TitleContainer}>
          <div className={"IA_FontSize_24"}>
            {new LocalizationService().strings.ContentOrganizer_PermissionsTargetingSelect}
          </div>
          <div>
            <p className={"IA_FontSize_14"}>{new LocalizationService().strings.ContentOrganizer_PermissionsTargetingSelectDescription}</p>
          </div>
        </div>
        <div className={styles.IPermissionsTargeting_BodyContainer}>
          <div style={{ clear: "both", marginTop: 30, display: !this.props.contentOrganizerStore.isLoadingApplication ? 'none' : 'block' }}>
            <IASpinner />
          </div>
          <div style={{ clear: "both", marginTop: 30, display: this.props.contentOrganizerStore.isLoadingApplication ? 'none' : 'block' }}>
            <ContentOrganizerPermissions
              beforeIaReady={() => {
                this.props.beforeIaReady();
              }}
              afterIaReady={() => {
                this.props.afterIaReady();
              }}
            />
          </div>
          {this.props.contentOrganizerStore.selectedTemplate !== "basic" &&
            <div style={{ clear: "both", marginTop: 20, display: this.props.contentOrganizerStore.isLoadingApplication ? 'none' : 'inline-flex' }}>
              <IATargetingApplication
                hideProfileInformation={this.props.contentOrganizerStore.hideProfileInformation}
                environment={this.props.contentOrganizerStore.environment}
                tenant={this.props.contentOrganizerStore.tenant}
                token={this.props.contentOrganizerStore.token}
                item={ this.props.contentOrganizerStore.selectedSiteItem}
                style={{ paddingLeft: 0, overflow: "inherit" }}
                close={() => { }}
                onChange={(newState) => {
                  this.props.contentOrganizerStore.enableTargeting = newState.enableTargeting;
                  this.props.contentOrganizerStore.allValues = newState.allValues;
                  this.props.contentOrganizerStore.radioValue = newState.radioValue;
                  this.props.contentOrganizerStore.storedValues = newState.storedValues;
                  this.props.contentOrganizerStore.treeValues = newState.treeValues;
                  this.props.contentOrganizerStore.selectedValues = newState.selectedValues;
                }}
                open={true}
                isApplication={undefined !== this.props.contentOrganizerStore.applicationName}
                applicationName={this.props.contentOrganizerStore.applicationName}
              />
            </div>
          }
        </div>
        <div className={styles.IPermissionsTargeting_BodyContainerRight}>
          <div className={styles.IPermissionsTargeting_Img}>
            <img src={"https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/wizard4.svg"} />
          </div>
        </div>
      </div>);

    return panel;
  }
}